import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 3000 } }

  connect() {
    this.resume()
  }

  disconnect() {
    this.pause()
  }

  pause() {
    clearTimeout(this.timer)
  }

  resume() {
    this.pause()
    this.timer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  dismiss() {
    if (parseFloat(getComputedStyle(this.element).transitionDuration) === 0) {
      this.element.remove()
      return
    }

    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
    this.element.classList.add("removing")
  }
}
